require('swagger-ui/dist/swagger-ui.css');
const SwaggerUI = require('swagger-ui');
const spec = require('./gpapi-docs.json');

SwaggerUI({
    spec,
    dom_id: '#swagger',
});
